import * as types from './mutation-types.js'
 
const actions={
	storageUserInfo({commit},data){
		commit(types.STORAGE_USERINFO, data)
	},
	isShowLoading({commit},data){
		commit(types.LOADING,data)
	},
	selectedVideo({commit},data){
		 commit(types.RECORDED,data)
	},
	receiveVideoUrl({commit},data){
		commit(types.VIDEOURL,data)
	},
	receiveWxShare({commit},data){
		commit(types.WXSHARE,data)
	},
	receiveRecording({commit},data){
		commit(types.RECORDING,data)
	},
	selectedMeeting({commit},data){
		commit(types.MEETING_ID,data)
   },
}
export default actions;


// WEBPACK FOOTER //
// ./src/store/actions.js